var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import * as React from 'react'; // tslint:disable-line
import { useState } from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';
import { classNames, urlDomain, fileType, formatFileSize, urlFilename, extname, firstStringProperty } from '@shapeable/utils';
import { isImageFile } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { Button } from '../elements/button';
import { pickBy } from 'lodash';
import { ClipLoader as Spinner } from 'react-spinners';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { useLang } from '../hooks/use-lang';
import { useImageDimensions } from '../hooks/use-image-dimensions';
import { useScript } from '../hooks/use-script';
import { AppButton } from '../app';
import { useThemeEval } from '../hooks/use-theme-eval';
import { opacityToHex } from '../utils/opacity-to-hex';
import { useEnv } from '../hooks/use-env';
var cls = classNames('form-field-file');
export var CLOUDINARY_FILE_OPTIONS = {
  showUploadMoreButton: false,
  multiple: false,
  sources: ['local', 'url', 'dropbox']
};
export var CLOUDINARY_IMAGE_OPTIONS = {
  showUploadMoreButton: false,
  multiple: false,
  styles: {
    palette: {
      link: "#FF5928"
    },
    fonts: {
      "'IBM Plex Sans', sans-serif": "https://fonts.googleapis.com/css?family=IBM+Plex+Sans"
    }
  },
  // @ts-ignore
  sources: ['local', 'image_search', 'unsplash', 'url', 'dropbox']
};
export var FormFieldFileDefaultProps = {
  autoComplete: 'off',
  mode: 'file',
  maxPreviewWidth: 200,
  onDeriveUrl: function (url) {
    return url;
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n  "], ["\n    display: flex;\n    align-items: flex-start;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    border-radius: ", ";\n    background-color: ", ";\n\n    ", "\n  "], ["\n    width: 100%;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    border-radius: ", ";\n    background-color: ", ";\n\n    ", "\n  "])), theme.UNIT(2), theme.COLOR('subtle-chrome'), function (props) {
    return !props._hasValue && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding: ", ";\n      border: ", " 2px dotted;\n      width: auto;\n      max-width: 100%;\n      flex-grow: 0;\n    "], ["\n      padding: ", ";\n      border: ", " 2px dotted;\n      width: auto;\n      max-width: 100%;\n      flex-grow: 0;\n    "])), theme.UNIT(3), theme.COLOR('line-subtle'));
  }),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-direction: row;\n    border: 1px solid ", ";\n\n    ", "\n  "], ["\n    flex-direction: row;\n    border: 1px solid ", ";\n\n    ", "\n  "])), theme.COLOR('line-mid'), function (props) {
    return !props._hasValue && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      max-width: 235px;\n      padding: 0;\n    "], ["\n      max-width: 235px;\n      padding: 0;\n    "])));
  })
});
var PreviewStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    box-sizing: border-box;\n    flex-shrink: 0;\n    display: flex;\n    max-width: 150px;\n    align-items: center;\n    justify-content: flex-start;\n    border-radius: ", ";\n  "], ["\n    box-sizing: border-box;\n    flex-shrink: 0;\n    display: flex;\n    max-width: 150px;\n    align-items: center;\n    justify-content: flex-start;\n    border-radius: ", ";\n  "])), theme.UNIT(2)),
  tablet: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    padding: ", ";\n    padding-right: 0;\n    max-width: 150px;\n    ", "\n\n  "], ["\n    padding: ", ";\n    padding-right: 0;\n    max-width: 150px;\n    ", "\n\n  "])), theme.UNIT(3), function (props) {
    return props._maxWidth && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      max-width: ", "px;\n    "], ["\n      max-width: ", "px;\n    "])), props._maxWidth);
  })
});
var ButtonStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    max-width: 400px;\n    font-size: ", ";\n  "], ["\n    max-width: 400px;\n    font-size: ", ";\n  "])), theme.FONT_SIZE(13))
});
var ChooseButtonStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ButtonStyles),
  tablet: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ClearButtonStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", ";\n    margin-left: ", ";\n  "], ["\n    ", ";\n    margin-left: ", ";\n  "])), ButtonStyles, theme.UNIT(3))
});
var ButtonsStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: flex;\n    margin-bottom: ", ";\n  "], ["\n    display: flex;\n    margin-bottom: ", ";\n  "])), theme.UNIT(6))
});
var ImageStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    max-width: 100%;\n    max-height: 150px;\n    display: block;\n    background: #FFF;\n\n    ", "\n\n  "], ["\n    max-width: 100%;\n    max-height: 150px;\n    display: block;\n    background: #FFF;\n\n    ", "\n\n  "])), function (props) {
    return props.isInverted && css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), theme.COLOR('dark'));
  })
});
var SpinnerStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n    margin-right: ", ";\n  "], ["\n    width: ", ";\n    height: ", ";\n    margin-right: ", ";\n  "])), theme.UNIT(4), theme.UNIT(4), theme.UNIT(2))
});
var ButtonLabelStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    padding-left: ", ";\n    display: inline-block;\n  "], ["\n    padding-left: ", ";\n    display: inline-block;\n  "])), theme.UNIT(2))
});
var FileNameStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    text-decoration: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    padding-left: 2px;\n    margin-top: ", ";\n    margin-bottom: ", ";\n    max-width: 300px;\n\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    color: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    text-decoration: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    padding-left: 2px;\n    margin-top: ", ";\n    margin-bottom: ", ";\n    max-width: 300px;\n\n    &:hover {\n      color: ", ";\n    }\n  "])), theme.COLOR('strong-chrome'), theme.FONT_SIZE(14), theme.UNIT(1), theme.UNIT(3), theme.COLOR('strong')),
  tablet: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    margin-top: 0;\n    padding-left: 2px;\n    margin-bottom: ", ";\n  "], ["\n    margin-top: 0;\n    padding-left: 2px;\n    margin-bottom: ", ";\n  "])), theme.UNIT(5))
});
var InputStyles = breakpoints({
  base: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var PropertiesStyles = breakpoints({
  base: css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    display: flex;\n    align-items: flex-start;\n    padding-left: 2px;\n    padding-bottom: ", ";\n    flex-wrap: wrap;\n  "], ["\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    display: flex;\n    align-items: flex-start;\n    padding-left: 2px;\n    padding-bottom: ", ";\n    flex-wrap: wrap;\n  "])), theme.UNIT(5)),
  tablet: css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    flex-wrap: nowrap;\n  "], ["\n    flex-wrap: nowrap;\n  "])))
});
var DetailsStyles = breakpoints({
  base: css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    padding-top: ", ";\n    padding-bottom: 0;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    padding-top: ", ";\n    padding-bottom: 0;\n  "])), theme.UNIT(1)),
  tablet: css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    padding-top: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n  "], ["\n    padding-top: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), theme.UNIT(5), theme.UNIT(5), theme.UNIT(5.5))
});
var PropertyItemStyles = breakpoints({
  base: css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    align-items: center;\n    font-weight: 500;\n    font-size: ", ";\n    padding-right: ", ";\n    border-right: 2px solid ", ";\n    margin-right: ", ";\n    margin-bottom: ", ";\n    &:last-child {\n      margin-right: 0;\n      border-right: none;\n    }\n  "], ["\n    align-items: center;\n    font-weight: 500;\n    font-size: ", ";\n    padding-right: ", ";\n    border-right: 2px solid ", ";\n    margin-right: ", ";\n    margin-bottom: ", ";\n    &:last-child {\n      margin-right: 0;\n      border-right: none;\n    }\n  "])), theme.FONT_SIZE(14), theme.UNIT(4), theme.COLOR('line-subtle'), theme.UNIT(4), theme.UNIT(2))
});
var NoFileStyles = breakpoints({
  base: css(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", ";\n    margin-bottom: ", ";\n    font-weight: 500;\n    padding-left: 2px;\n  "], ["\n    color: ", ";\n    font-size: ", ";\n    margin-bottom: ", ";\n    font-weight: 500;\n    padding-left: 2px;\n  "])), theme.COLOR('text-subtle'), theme.FONT_SIZE(14), theme.UNIT(5))
});
var FetchingDimensionsStyles = breakpoints({
  base: css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.COLOR('text-subtle'))
});
// -------- Components -------->
var My = {
  Layout: styled.div(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Input: styled.input(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  Preview: styled.div(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), PreviewStyles),
  Image: styled.img(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Button: styled(Button)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  Buttons: styled.div(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), ButtonsStyles),
  ChooseButton: styled(AppButton)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), ChooseButtonStyles),
  ClearButton: styled(AppButton)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), ClearButtonStyles),
  Spinner: styled(Spinner)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), SpinnerStyles),
  ButtonLabel: styled.div(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), ButtonLabelStyles),
  FileName: styled.a(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), FileNameStyles),
  NoFile: styled.span(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), NoFileStyles),
  Properties: styled.ul(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), PropertiesStyles),
  PropertyItem: styled.li(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), PropertyItemStyles),
  Body: styled.div(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Details: styled.div(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), DetailsStyles),
  FetchingDimensions: styled.span(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), FetchingDimensionsStyles)
};
var GlobalStyle = createGlobalStyle(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n  .upload_button_holder {\n    button {\n      border-radius: ", ";\n    }\n  }\n"], ["\n  .upload_button_holder {\n    button {\n      border-radius: ", ";\n    }\n  }\n"])), theme.UNIT(8));
export var FormFieldFile = function (props) {
  var className = props.className,
    name = props.name,
    onChange = props.onChange,
    maxPreviewWidth = props.maxPreviewWidth,
    onDeriveUrl = props.onDeriveUrl,
    mode = props.mode,
    options = props.options;
  // this has now been updated to reflect the fact that "value" is now a file object and not just the URL
  var value = props.value || {
    url: ''
  };
  var url = value.url,
    typeName = value.typeName,
    formattedSize = value.formattedSize,
    filename = value.filename;
  var env = useEnv();
  var t = useLang();
  var _a = __read(useState(false), 2),
    preparing = _a[0],
    setPreparing = _a[1];
  var $ = useThemeEval();
  var cloudinaryOptions = __assign(__assign({}, mode === 'file' ? CLOUDINARY_FILE_OPTIONS : CLOUDINARY_IMAGE_OPTIONS), props.cloudinaryOptions);
  cloudinaryOptions.styles = {
    palette: {
      link: $(theme.COLOR('text-chrome')),
      tabIcon: $(theme.COLOR('text-chrome'))
    },
    frame: {
      background: "".concat($(theme.COLOR('strong-chrome'))).concat(opacityToHex(0.7))
    },
    fonts: {
      "'Poppins', sans-serif": "https://fonts.googleapis.com/css?family=Poppins"
    }
  };
  if (options.useCropping) {
    cloudinaryOptions.cropping = 'server';
  }
  // theme functions return a function to evaluate the theme value on a theme object (passed in via context) 
  var spinnerColor = theme.COLOR('light')(props);
  var onUploadEvent = function (error, result) {
    var _a;
    if (result.event === 'success') {
      var info = result.info;
      if (info && info.secure_url) {
        var url_1 = onDeriveUrl(result.info.secure_url);
        var extension = extname(info.path);
        var filename_1 = "".concat(info.original_filename).concat(extension);
        var thumbnails = mode === 'image' && {
          large: {
            url: url_1,
            width: info.width,
            height: info.height
          }
        };
        var file = pickBy({
          filename: filename_1,
          width: info.width,
          height: info.height,
          formattedSize: formatFileSize(info.bytes),
          typeName: fileType(filename_1),
          thumbnails: thumbnails
        });
        var data = {
          file: file
        };
        // provide metadata to update the file info with any info we have from cloudinary
        onChange({
          value: __assign(__assign({}, file), {
            url: url_1
          }),
          mutationValue: url_1,
          extraState: (_a = {}, _a["".concat(name, "Data")] = {
            value: JSON.stringify(data),
            mutationValue: JSON.stringify(data)
          }, _a),
          meta: data
        });
      }
    }
    if (result.event === 'display-changed' && result.info === 'shown') {
      setPreparing(false);
    }
  };
  var clearValue = function () {
    var _a;
    if (confirm(t('Are you sure you wish to clear this file?'))) {
      onChange({
        value: {
          url: ''
        },
        meta: {
          file: {}
        },
        extraState: (_a = {}, _a["".concat(name, "Data")] = {
          value: '',
          mutationValue: ''
        }, _a)
      });
    }
  };
  var win = window;
  var _b = __read(useScript('https://widget.cloudinary.com/v2.0/global/all.js'), 2),
    loaded = _b[0],
    error = _b[1];
  // console.log("FormFieldFile loaded", { loaded, error });
  var showUploadWidget = function () {
    if (!env.CLOUDINARY_CLOUD_NAME) {
      console.error('CLOUDINARY_CLOUD_NAME is not set');
    }
    if (!env.CLOUDINARY_UPLOAD_PRESET) {
      console.error('CLOUDINARY_UPLOAD_PRESET is not set');
    }
    if (win && win.cloudinary && env.CLOUDINARY_CLOUD_NAME && env.CLOUDINARY_UPLOAD_PRESET) {
      setPreparing(true);
      win.cloudinary.openUploadWidget(__assign({
        cloudName: env.CLOUDINARY_CLOUD_NAME,
        uploadPreset: env.CLOUDINARY_UPLOAD_PRESET,
        googleApiKey: env.GOOGLE_SEARCH_API_KEY
      }, cloudinaryOptions), onUploadEvent);
    }
  };
  var _c = __read(useImageDimensions(url), 2),
    derivedWidth = _c[0],
    derivedHeight = _c[1];
  var replaceLabel = mode === 'file' ? t('Replace File...') : t('Replace Image...');
  var chooseLabel = mode === 'file' ? t('Choose File...') : t('Choose Image...');
  var noFileLabel = mode === 'file' ? t('No File Selected') : t('No Image Selected');
  var buttonLabel = preparing ? React.createElement(React.Fragment, null, React.createElement(My.Spinner, {
    color: spinnerColor,
    size: 12
  }), React.createElement(My.ButtonLabel, null, t('Please wait...'))) : value ? replaceLabel : chooseLabel;
  var width = isImageFile(value) && (value.width || derivedWidth);
  var height = isImageFile(value) && (value.height || derivedHeight);
  var thumbnail = firstStringProperty(value, ['typeImage.url', 'thumbnails.large.url']);
  var previewThumbnail = mode === 'image' ? url || thumbnail : thumbnail;
  var domain = urlDomain(url);
  return React.createElement(My.Layout, {
    className: className
  }, React.createElement(GlobalStyle, null), React.createElement(My.Input, {
    id: name,
    value: url,
    name: name,
    type: "hidden"
  }), React.createElement(My.Body, {
    _hasValue: !!url
  }, previewThumbnail && React.createElement(My.Preview, {
    isInverted: options === null || options === void 0 ? void 0 : options.isInverted,
    _maxWidth: maxPreviewWidth
  }, React.createElement(Zoom, null, React.createElement(My.Image, {
    isInverted: options === null || options === void 0 ? void 0 : options.isInverted,
    src: previewThumbnail
  }))), React.createElement(My.Details, null, url ? React.createElement(My.FileName, {
    title: t('Open in New Tab'),
    target: "_blank",
    href: url
  }, value.filename || value && urlFilename(url)) : React.createElement(My.NoFile, null, noFileLabel), React.createElement(My.Buttons, null, React.createElement(My.ChooseButton, {
    action: "choose",
    disabled: !loaded || preparing,
    onClick: showUploadWidget
  }, buttonLabel), value && React.createElement(My.ClearButton, {
    onClick: clearValue,
    action: "clear"
  }, t('Clear File...'))), value && React.createElement(My.Properties, null, value.typeName && React.createElement(My.PropertyItem, null, value.typeName), domain && React.createElement(My.PropertyItem, null, "@", ' ', domain), value.formattedSize && value.formattedSize !== "0 B" && React.createElement(My.PropertyItem, null, value.formattedSize), mode === 'image' && React.createElement(My.PropertyItem, null, width && height && React.createElement(React.Fragment, null, width, " \u00D7 ", height)
  // <My.FetchingDimensions>{t('Fetching...')}</My.FetchingDimensions>
  )))));
};
FormFieldFile.defaultProps = FormFieldFileDefaultProps;
FormFieldFile.cls = cls;
export var createFormFieldFile = function (props) {
  return React.createElement(FormFieldFile, __assign({}, props));
};
export var createInputImageUpload = function (props) {
  return React.createElement(FormFieldFile, __assign({}, props, {
    mode: "image"
  }));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46;